<template>
    <div id="produtos">
        <div class="produtos-chamada">
            <h3>nuestros</h3>
            <h2>productos</h2>
        </div>
        <div class="produtos">
            <div class="thumb hover">
                <figure>
                    <img @click="show('oitosegundos')" src="../assets/produtos/thumbs/8seg.png" alt="">
                </figure>
            </div>
            <div class="thumb hover thumb2">
                <figure>
                    <img @click="show('refricola')" src="../assets/produtos/thumbs/refricola.png" alt="">
                </figure>
            </div>
            <div class="thumb hover">
                <figure>
                    <img @click="show('limao')" src="../assets/produtos/thumbs/limao.png" alt="">
                </figure>
            </div>
            <div class="thumb hover thumb2">
                <figure>
                    <img @click="show('guarana')" src="../assets/produtos/thumbs/guarana.png" alt="">
                </figure>
            </div>
            <div class="thumb hover thumb2">
                <figure>
                    <img @click="show('tubaina')" src="../assets/produtos/thumbs/tubaina.png" alt="">
                </figure>
            </div>
            <div class="thumb hover">
                <figure>
                    <img @click="show('laranja')" src="../assets/produtos/thumbs/laranja.png" alt="">
                </figure>
            </div>
            <div class="thumb hover">
                <figure>
                    <img @click="show('citrus')" src="../assets/produtos/thumbs/citrus.png" alt="">
                </figure>
            </div>
            <div class="thumb hover">
                <figure>
                    <img @click="show('rc')" src="../assets/produtos/thumbs/rccola.png" alt="">
                </figure>
            </div>
            <div class="thumb hover">
                <figure>
                    <img @click="show('uva')" src="../assets/produtos/thumbs/uva.png" alt="">
                </figure>
            </div>
        </div>

        <modal name="oitosegundos" 
            transition="nice-modal-fade"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="90%"
            height="auto"
        >
            <div class="oitosegundos">
                <div class="row">
                    <div class="col-md-4 oitosegundos-left">
                        <img src="../assets/produtos/oitosegundos/produto_g.png" alt="">
                    </div>
                    <div class="col-md-8 oitosegundos-right">
                        <div class="row">
                            <div class="col-md-12 oitosegundos-produtos">
                                <img src="../assets/produtos/oitosegundos/produto_p.png" alt="">
                            </div>
                            <div class="col-md-12 refricola-tabela">
                                <img src="../assets/produtos/oitosegundos/tabela.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="refricola" 
            transition="nice-modal-fade"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="90%"
            height="auto"
        >
            <div class="refricola">
                <div class="row">
                    <div class="col-md-4 refricola-left">
                        <img src="../assets/produtos/refricola/produto_g.png" alt="">
                    </div>
                    <div class="col-md-8 refricola-right">
                        <div class="row">
                            <div class="col-md-12 refricola-produtos">
                                <img src="../assets/produtos/refricola/produto_p.png" alt="">
                            </div>
                            <div class="col-md-12 refricola-tabela">
                                <img src="../assets/produtos/refricola/tabela.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="limao" 
            transition="nice-modal-fade"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="90%"
            height="auto"
        >
            <div class="limao">
                <div class="row">
                    <div class="col-md-4 limao-left">
                        <img src="../assets/produtos/limao/produtos_g.png" alt="">
                    </div>
                    <div class="col-md-8 limao-right">
                        <div class="row">
                            <div class="col-md-12 limao-produtos">
                                <img src="../assets/produtos/limao/produtos_p.png" alt="">
                            </div>
                            <div class="col-md-12 limao-tabela">
                                <img src="../assets/produtos/limao/tabela.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="guarana" 
            transition="nice-modal-fade"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="90%"
            height="auto"
        >
            <div class="guarana">
                <div class="row">
                    <div class="col-md-4 guarana-left">
                        <img src="../assets/produtos/guarana/produto_g.png" alt="">
                    </div>
                    <div class="col-md-8 guarana-right">
                        <div class="row">
                            <div class="col-md-12 guarana-produtos">
                                <img src="../assets/produtos/guarana/produto_p.png" alt="">
                            </div>
                            <div class="col-md-12 guarana-tabela">
                                <img src="../assets/produtos/guarana/tabela.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="tubaina" 
            transition="nice-modal-fade"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="90%"
            height="auto"
        >
            <div class="tubaina">
                <div class="row">
                    <div class="col-md-4 tubaina-left">
                        <img src="../assets/produtos/tubaina/produto_g.png" alt="">
                    </div>
                    <div class="col-md-8 tubaina-right">
                        <div class="row">
                            <div class="col-md-12 tubaina-produtos">
                                <img src="../assets/produtos/tubaina/produto_p.png" alt="">
                            </div>
                            <div class="col-md-12 tubaina-tabela">
                                <img src="../assets/produtos/tubaina/tabela.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="laranja" 
            transition="nice-modal-fade"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="90%"
            height="auto"
        >
            <div class="laranja">
                <div class="row">
                    <div class="col-md-4 laranja-left">
                        <img src="../assets/produtos/laranja/produto_g.png" alt="">
                    </div>
                    <div class="col-md-8 laranja-right">
                        <div class="row">
                            <div class="col-md-12 laranja-produtos">
                                <img src="../assets/produtos/laranja/produto_p.png" alt="">
                            </div>
                            <div class="col-md-12 laranja-tabela">
                                <img src="../assets/produtos/laranja/tabela.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="citrus" 
            transition="nice-modal-fade"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="90%"
            height="auto"
        >
            <div class="citrus">
                <div class="row">
                    <div class="col-md-4 citrus-left">
                        <img src="../assets/produtos/citrus/produto_g.png" alt="">
                    </div>
                    <div class="col-md-8 citrus-right">
                        <div class="row">
                            <div class="col-md-12 citrus-produtos">
                                <img src="../assets/produtos/citrus/produto_p.png" alt="">
                            </div>
                            <div class="col-md-12 citrus-tabela">
                                <img src="../assets/produtos/citrus/tabela.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="rc" 
            transition="nice-modal-fade"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="90%"
            height="auto"
        >
            <div class="rc">
                <div class="row">
                    <div class="col-md-4 rc-left">
                        <img src="../assets/produtos/rc/produto_g.png" alt="">
                    </div>
                    <div class="col-md-8 rc-right">
                        <div class="row">
                            <div class="col-md-12 rc-produtos">
                                <img src="../assets/produtos/rc/produto_p.png" alt="">
                            </div>
                            <div class="col-md-12 rc-tabela">
                                <img src="../assets/produtos/rc/tabela.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
        <modal name="uva" 
            transition="nice-modal-fade"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="90%"
            height="auto"
        >
            <div class="uva">
                <div class="row">
                    <div class="col-md-4 uva-left">
                        <img src="../assets/produtos/uva/produto_g.png" alt="">
                    </div>
                    <div class="col-md-8 uva-right">
                        <div class="row">
                            <div class="col-md-12 uva-produtos">
                                <img src="../assets/produtos/uva/produto_p.png" alt="">
                            </div>
                            <div class="col-md-12 uva-tabela">
                                <img src="../assets/produtos/uva/tabela.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    methods: {
        show (name) {
            this.$modal.show(name);
        },
        hide (name) {
            this.$modal.hide(name);
        }
    }
}
</script>


<style scoped>

.oitosegundos {
    width: 100%;
    height: 100%;
    background-color: #013A6B;
    background-image: -webkit-linear-gradient(90deg, #000 67%, #fff 50%);
}

.oitosegundos-left {
    text-align: center;
    padding: 20px;
}

.oitosegundos-left img {
    width: 45%;
}

.oitosegundos-right {
    text-align: center;
    padding: 65px;
}

.oitosegundos-produtos {
    display: inline;
}

.oitosegundos-tabela {
    margin-top: 80px;
}

@media only screen and (min-width: 320px) and (max-width: 720px) {
    .oitosegundos {
        background-image: -webkit-linear-gradient(90deg, #000 67%, #fff 50%);
    }

    .oitosegundos-produtos {
        
    }
    .oitosegundos-right {
        text-align: center;
        padding: 0px 35px 35px 35px;
    }
    .oitosegundos-left img {
        width: 38%;
    }
}

.refricola {
    width: 100%;
    height: 100%;
    background-color: #013A6B;
    background-image: -webkit-linear-gradient(90deg, #95010d 67%, #ff0012 50%);
}

.refricola-left {
    text-align: center;
    padding: 20px;
}

.refricola-left img {
    width: 45%;
}

.refricola-right {
    text-align: center;
    padding: 65px;
}

.refricola-produtos {
    display: inline;
}

.refricola-tabela {
    margin-top: 80px;
}

@media only screen and (min-width: 320px) and (max-width: 720px) {
    .refricola {
        background-image: -webkit-linear-gradient(90deg, #95010d 83%, #ff0012 50%);
    }

    .refricola-produtos {
        
    }
    .refricola-right {
        text-align: center;
        padding: 0px 35px 35px 35px;
    }
    .refricola-left img {
        width: 38%;
    }
}

.limao {
    width: 100%;
    height: 100%;
    background-color: #013A6B;
    background-image: -webkit-linear-gradient(90deg, #58a847 67%, #68c155 50%);
}

.limao-left {
    text-align: center;
    padding: 20px;
}

.limao-left img {
    width: 45%;
}

.limao-right {
    text-align: center;
    padding: 65px;
}

.limao-produtos {
    display: inline;
}

.limao-tabela {
    margin-top: 80px;
}

@media only screen and (min-width: 320px) and (max-width: 720px) {
    .limao {
        background-image: -webkit-linear-gradient(90deg, #58a847 82%, #68c155 50%);
    }

    .limao-produtos {
        
    }
    .limao-right {
        text-align: center;
        padding: 0px 35px 35px 35px;
    }
    .limao-left img {
        width: 38%;
    }
}

.guarana {
    width: 100%;
    height: 100%;
    background-color: #013A6B;
    background-image: -webkit-linear-gradient(90deg, #015b1b 67%, #1a9f2c 50%);
}

.guarana-left {
    text-align: center;
    padding: 20px;
}

.guarana-left img {
    width: 45%;
}

.guarana-right {
    text-align: center;
    padding: 65px;
}

.guarana-produtos {
    display: inline;
}

.guarana-tabela {
    margin-top: 80px;
}

@media only screen and (min-width: 320px) and (max-width: 720px) {
    .guarana {
        background-image: -webkit-linear-gradient(90deg, #015b1b 67%, #1a9f2c 50%);
    }

    .guarana-produtos {
        
    }
    .guarana-right {
        text-align: center;
        padding: 0px 35px 35px 35px;
    }
    .guarana-left img {
        width: 38%;
    }
}


.tubaina {
    width: 100%;
    height: 100%;
    background-color: #013A6B;
    background-image: -webkit-linear-gradient(90deg, #f2cf01 67%, #fff 50%);
}

.tubaina-left {
    text-align: center;
    padding: 20px;
}

.tubaina-left img {
    width: 45%;
}

.tubaina-right {
    text-align: center;
    padding: 65px;
}

.tubaina-produtos {
    display: inline;
}

.tubaina-tabela {
    margin-top: 80px;
}

@media only screen and (min-width: 320px) and (max-width: 720px) {
    .tubaina {
        background-image: -webkit-linear-gradient(90deg, #f2cf01 82%, #fff 50%);
    }

    .tubaina-produtos {
        
    }
    .tubaina-right {
        text-align: center;
        padding: 0px 35px 35px 35px;
    }
    .tubaina-left img {
        width: 38%;
    }
}

.laranja {
    width: 100%;
    height: 100%;
    background-color: #013A6B;
    background-image: -webkit-linear-gradient(90deg, #d25c2e 67%, #eab438 50%);
}

.laranja-left {
    text-align: center;
    padding: 20px;
}

.laranja-left img {
    width: 45%;
}

.laranja-right {
    text-align: center;
    padding: 65px;
}

.laranja-produtos {
    display: inline;
}

.laranja-tabela {
    margin-top: 80px;
}

@media only screen and (min-width: 320px) and (max-width: 720px) {
    .laranja {
        background-image: -webkit-linear-gradient(90deg, #d25c2e 82%, #eab438 50%);
    }

    .laranja-produtos {
        
    }
    .laranja-right {
        text-align: center;
        padding: 0px 35px 35px 35px;
    }
    .laranja-left img {
        width: 38%;
    }
}

.citrus {
    width: 100%;
    height: 100%;
    background-color: #013A6B;
    background-image: -webkit-linear-gradient(90deg, #c3de03 67%, #90b227 50%);
}

.citrus-left {
    text-align: center;
    padding: 20px;
}

.citrus-left img {
    width: 45%;
}

.citrus-right {
    text-align: center;
    padding: 65px;
}

.citrus-produtos {
    display: inline;
}

.citrus-tabela {
    margin-top: 80px;
}

@media only screen and (min-width: 320px) and (max-width: 720px) {
    .citrus {
        background-image: -webkit-linear-gradient(90deg, #c3de03 82%, #90b227 50%);
    }

    .citrus-produtos {
        display: none;
    }
    .citrus-right {
        text-align: center;
        padding: 0px 35px 35px 35px;
    }
    .citrus-left img {
        width: 38%;
    }
}

.rc {
    width: 100%;
    height: 100%;
    background-color: #013A6B;
    background-image: -webkit-linear-gradient(90deg, #ff0012 67%, #014fb1 50%);
}

.rc-left {
    text-align: center;
    padding: 20px;
}

.rc-left img {
    width: 45%;
}

.rc-right {
    text-align: center;
    padding: 65px;
}

.rc-produtos {
    display: inline;
}

.rc-tabela {
    margin-top: 80px;
}

@media only screen and (min-width: 320px) and (max-width: 720px) {
    .rc {
        background-image: -webkit-linear-gradient(90deg, #ff0012 82%, #014fb1 50%);
    }

    .rc-produtos {
        
    }
    .rc-right {
        text-align: center;
        padding: 0px 35px 35px 35px;
    }
    .rc-left img {
        width: 38%;
    }
}

.uva {
    width: 100%;
    height: 100%;
    background-color: #013A6B;
    background-image: -webkit-linear-gradient(90deg, #622165 67%, #801f66 50%);
}

.uva-left {
    text-align: center;
    padding: 20px;
}

.uva-left img {
    width: 45%;
}

.uva-right {
    text-align: center;
    padding: 65px;
}

.uva-produtos {
    display: inline;
}

.uva-tabela {
    margin-top: 80px;
}

@media only screen and (min-width: 320px) and (max-width: 720px) {
    .uva {
        background-image: -webkit-linear-gradient(90deg, #622165 67%, #801f66 50%);
    }

    .uva-produtos {
        display: none;
    }
    .uva-right {
        text-align: center;
        padding: 0px 35px 35px 35px;
    }
    .uva-left img {
        width: 38%;
    }
}

* {
	box-sizing: border-box;
}

#produtos {
    background: #ededed;
}

.demo-modal-class {
    border-radius: 5px;
    background: #F7F7F7;
    box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
  }

  .size-modal-content {
    padding: 10px;
    font-style: 13px;
  }
  .v--modal-overlay[data-modal="size-modal"] {
    background: rgba(0, 0, 0, 0.8);
  }

.produtos {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 50px 50px 50px 50px;
}

.container{
    width: 100%;
}

img {
	max-width: 100%;
}

.container {
	display: flex;
	flex-wrap: wrap;
	height: 100vh;
}

.thumb {
	/* border: 2px solid green; */
	flex: 1 1 25%;
	display: flex;
	align-items: center;
    justify-content: center;
    overflow: hidden;
    cursor: pointer;
}

.thumb2 {
    flex: 1 1 50%;
}

.hover figure img {
	-webkit-transform: scale(1);
	transform: scale(1);
	-webkit-transition: .2s ease-in-out;
	transition: .2s ease-in-out;
}
.hover figure:hover img {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}

.produtos-chamada {
    padding-top: 50px;
    padding-left: 50px;
}

.produtos-chamada h2 {
  font-family: "Bambino";
  font-style: normal;
  font-size: 15pt;
  text-transform: uppercase;
}

.produtos-chamada h3 {
  font-family: "Bambino";
  font-style: normal;
  font-size: 10pt;
  text-transform: uppercase;
  font-weight: 300;
}

figure {
    margin: 0;
}

@media only screen and (min-width: 320px) and (max-width: 1024px) {

    .thumb {
        flex: 1 1 50%;
    }

    .thumb2 {
        flex: 1 1 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Produtos.vue